// extracted by mini-css-extract-plugin
export var buttons = "br_bC";
export var left = "br_b8";
export var media = "br_gX";
export var right = "br_ck";
export var section = "br_j";
export var selected = "br_bg";
export var signature = "br_gW";
export var testimonial = "br_gV";
export var text = "br_bw";
export var textContainer = "br_b6";
export var video = "br_gb";